<template>
  <b-row align-h="center">
    <div class="w-75">
      <b-col cols="12">
        <FITFormCard>
          <div slot="header">
            <b-row align-v="center">
              <b-col cols="7">
                <p class="h5">{{ $t('my.profile.header') }}</p>
              </b-col>
              <b-col cols="5" class="text-right">
                <b-button variant="warning" size="md" class="text-white" @click="changePassword"><i class="fa fa-key mr-2"></i> Change Password</b-button>
              </b-col>
            </b-row>
          </div>
          <div slot="formBody">
            <b-row>
              <b-col cols="6" class="border-right border-light">
                <p class="h3"><i class="fa fa-user-circle mr-2"></i>{{ $t('my.profile.personalInformation') }}</p>
                <dd>
                  <ProfileRow :title="$t('my.profile.chineseName')" :value="form.chineseName"></ProfileRow>
                  <ProfileRow :title="$t('my.profile.englishName')" :value="form.englishName"></ProfileRow>
                  <ProfileRow :title="$t('general.gender')" :value="form.gender"></ProfileRow>
                  <ProfileRow :title="$t('general.identityCardNo')" :value="idCardNo"></ProfileRow>
                  <ProfileRow :title="$t('general.dateOfBirth')" :value="form.dateOfBirth | date"></ProfileRow>
                </dd>
              </b-col>
              <b-col cols="6">
                <p class="h3"><i class="fa fa-phone-square mr-2"></i>{{ $t('my.profile.contactInformation') }}</p>
                <dd>
                  <!-- <ProfileRow :title="$t('general.companyAddress')" :value="form.englishCompanyAddress"></ProfileRow> -->
                  <!-- <ProfileRow class="mb-3" :title="$t('general.chineseCompanyAddress')" :value="form.chineseCompanyAddress"></ProfileRow> -->
                  <ProfileRow :title="$t('general.residentialAddress')" :value="form.englishResidentialAddress"></ProfileRow>
                  <!-- <ProfileRow class="mb-3" :title="$t('general.chineseResidentialAddress')" :value="form.chineseResidentialAddress"></ProfileRow> -->
                  <ProfileRow :title="$t('general.correspondenceAddress')" :value="form.englishCorrespondenceAddress"></ProfileRow>
                  <!-- <ProfileRow class="mb-3" :title="$t('general.chineseCorrespondenceAddress')" :value="form.chineseCorrespondenceAddress"></ProfileRow> -->
                  <ProfileRow :title="$t('general.email')" :value="form.email"></ProfileRow>
                  <!-- <ProfileRow :title="$t('general.fax')" :value="form.fax"></ProfileRow> -->
                  <ProfileRow :title="$t('general.telephoneHome')" :value="form.telephoneHome"></ProfileRow>
                  <ProfileRow :title="$t('general.telephoneMobile')" :value="form.telephoneMobile"></ProfileRow>
                  <ProfileRow :title="$t('general.telephoneOffice')" :value="form.telephoneOffice"></ProfileRow>
                </dd>
              </b-col>
            </b-row>
          </div>
        </FITFormCard>
      </b-col>
    </div>
  </b-row>
</template>
<script type="text/javascript">
import Vue from 'vue';
import ProfileRow from './ProfileRow';
import {
  FITFormCard,
  FITSelect
} from '@/components';
export default {
  name: 'CustomerProfile',
  components: {
    ProfileRow,
    FITFormCard,
    FITSelect
  },

  data() {
    return {
      languages: [{
        text: 'English',
        value: 'english'
      }, {
        text: '繁體中文',
        value: 'zh_hk'
      }, {
        text: '简体中文',
        value: 'zh_cn'
      }],

      yesNo: [{
        'Y': 'Yes',
        'N': 'No'
      }],

      form: { language: 'english', correspondenceAddress: '', companyAddress: '', residentialAddress: '', chineseName: '', englishName: '', "ID": "42", "agentCode": "010000010", "contact": "2586", "agentTeam": "1", "position": "M", "agentType": "A", "status": "", "joinDate": null, "leaveDate": null, "cibLicense": null, "mpfaLicense": "", "ociLicensePrinciples": "", "ociLicenseGeneral": "", "ociLicenseLongTerm": "", "ociLicenseLinkedLongTerm": "", "ociLicenseTravel": "", "sfcLicenseType1": "", "sfcLicenseType2": "", "sfcLicenseType3": "", "sfcLicenseType4": "", "sfcLicenseType5": "", "sfcLicenseType6": "", "sfcLicenseType7": "", "sfcLicenseType8": "", "sfcLicenseType9": "", "sfcLicenseType10": "", "commAgentRatio": "0.5", "commOverrideRatio": "0.15", "version": "2", "createTime": "2018-03-28 18:33:18", "updateTime": "2018-07-02 15:31:00", "createUser": "4", "updateUser": "4", "title": "Ms", "englishLastname": "Chan", "englishFirstname": "Tsz Ching", "chineseLastname": "陳", "chineseFirstname": "梓晴", "nationality": "Chinese (Hong Kong)", "identityCardNo": "Y244647(7)", "idType": "HKID", "gender": "F", "dateOfBirth": "1992-07-08 00:00:00", "maritalStatus": "S", "contactType": "", "defaultAddress": "2642", "telephoneMobile": "", "telephoneHome": "", "telephoneOffice": "", "fax": "", "email": "", "chineseResidentialAddress": "", "englishResidentialAddress": "", "chineseCorrespondenceAddress": "", "englishCorrespondenceAddress": "", "chineseCompanyAddress": "", "englishCompanyAddress": "", "invalidAddress": "N" }
    }
  },
  created() {
    console.debug('created');
    this.$store.dispatch('My/getCustomer')
      .then((json) => {
        let data = json.data;
        let result = {
          ...data,
          chineseName: data.chineseLastname + data.chineseFirstname,
          englishName: data.englishFirstname + ' ' + data.englishLastname.toUpperCase(),
          englishCorrespondenceAddress: `${this.$options.filters.isEmpty(`${data.englishCorrespondenceAddress}`)}`,
          chineseCorrespondenceAddress: `${this.$options.filters.isEmpty(`${data.chineseCorrespondenceAddress}`)}`,
          englishCompanyAddress: `${this.$options.filters.isEmpty(`${data.englishCompanyAddress}`)}`,
          chineseCompanyAddress: `${this.$options.filters.isEmpty(`${data.chineseCompanyAddress}`)}`,
          englishResidentialAddress: `${this.$options.filters.isEmpty(`${data.englishResidentialAddress}`)}`,
          chineseResidentialAddress: `${this.$options.filters.isEmpty(`${data.chineseResidentialAddress}`)}`,
        };
        Vue.set(this, 'form', result);
      }).catch((error) => {
        console.error(error);
      })
  },
  methods: {
    onLanguageChanged(value) {
      this.$store.dispatch('My/editPreference', {
        language: value,
        version: this.form.version
      }).then(() => {
        if (value === 'english')
          value = 'en_us';

        this.$i18n.locale = value;
      });
    },

    changePassword() {
      this.$router.push('/my/changePassword');
    }
  },
  computed: {
    idCardNo() {
      return this.form.identityCardNo.slice(0, 4) + '****'
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/My/components/Profile/CustomerProfile.vue